import { actionType } from './configIntro.action'

const initState = {
  isLoading: false,
  config: {},
}

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actionType('course-layout').request:
      return {
        ...state,
        isLoading: true,
      }
    case actionType('course-layout').success:
      return {
        ...state,
        isLoading: false,
        config: action.payload.data,
      }
    case actionType('course-layout').error:
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}
